module.exports = __webpack_public_path__ + "media/images/cms/img_slide_20-bf24c965c073819e709530b0c54ff566.jpg";